import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6f050d71"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "head-container"
};
const _hoisted_3 = {
  class: "head-logo"
};
const _hoisted_4 = {
  href: "/teachCenter.html"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "head-infor"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  key: 2,
  class: "head-login"
};
const _hoisted_10 = {
  key: 3,
  class: "head-user"
};
const _hoisted_11 = {
  class: "avatar-box"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "user-name"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("退出");

import { getStorage, setStorage } from '@/plugins/store';
import { handleLogin, handleLogout } from '@/plugins/utils';
export default {
  props: {
    // 是否显示教研中心
    showTeachBtn: Boolean
  },
  emits: ['getUserInfo', 'userRole'],

  setup(__props, {
    emit
  }) {
    const $http = inject('$http');
    const $utils = inject('$utils');
    const $schoolId = inject('$schoolId');
    const userInfo = ref(null);
    const zhsRole = ref(0);
    const userRole = ref(0);
    const logoUrl = ref('');
    const backUrl = ref('/index.html'); // 获取用户信息

    const getUserInfo = async () => {
      let token = $utils.getCookie('X-Access-Token');

      if (token) {
        const res = await $http.getUserInfo();
        userInfo.value = res;
        setStorage('userInfo', res);
        console.log('用户信息', res);

        if (userInfo.uuid) {
          getUserZhsRole();
          getUserIdentity();
        }

        emit('getUserInfo', userInfo.value);
        return;
      }

      return null;
    };

    getUserInfo(); // 获取用户智慧树权限

    const getUserZhsRole = async () => {
      const res = await $http.getUserZhsIdentity({
        uuid: userInfo.uuid
      }); //  role = 2 有数据中心权限，role=0 虽然有myuni权限，但是没有数据中心权限 role = 1 数据中心权限、教学指挥中心权限,

      console.log('智慧树权限', res);
      zhsRole = res.role;
    }; // 获取用户智慧树角色


    const getUserIdentity = async () => {
      let params = {
        schoolId: $schoolId,
        uuid: userInfo.uuid
      };
      const res = await $http.getUserIdentity(params); // 	0:未认证 1:管理者 2:老师 3:学生

      console.log('智慧树角色', res);
      userRole = res;
      emit('userRole', userRole);
    }; // 基础配置信息


    const getBaseSet = async () => {
      const res = getStorage('projectBaseData') || {};
      logoUrl.value = res.home_logo_url || '';
    };

    getBaseSet();
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [logoUrl.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "logo",
        src: logoUrl.value
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("img", {
        class: "teaching-center",
        src: require('@/assets/images/教研中心.png')
      }, null, 8, _hoisted_6)])]), _createElementVNode("div", _hoisted_7, [userInfo.value ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "online",
        href: backUrl.value,
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
        target: "_blank"
      }, " 门户首页 ", 8, _hoisted_8)) : _createCommentVNode("", true), userInfo.value && __props.showTeachBtn ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        class: "online",
        href: "/teachCenter.html",
        onClick: _cache[1] || (_cache[1] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
        target: "_blank"
      }, " 教研中心 ")) : _createCommentVNode("", true), !userInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
        class: "login-btn",
        onClick: _cache[2] || (_cache[2] = $event => _unref(handleLogin)())
      }, "登录")])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        class: "avatar",
        src: userInfo.value.avatar ? userInfo.value.avatar : require('@/assets/images/user_icon.png')
      }, null, 8, _hoisted_12)]), _createVNode(_component_el_dropdown, {
        trigger: "hover",
        "show-arrow": false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _unref(handleLogout)
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(userInfo.value.realname), 1)]),
        _: 1
      })]))])])]);
    };
  }

};